module.exports = __webpack_public_path__ + "img/Desk Stationeryd14.db18eb59.jpg";